// import { Stars } from "react-bootstrap-icons";
import {
  group_icon,
  petrol_pump,
  // rental_car,
  stars,
  mileage,
  // star,
} from "../../../assets/images";
import { useDispatch, useSelector } from "react-redux";
import { setBookingValues } from "../../../Redux/BookingData/bookingDataSlice";
// import { json } from "stream/consumers";
import React, { useEffect, useState } from "react";
import axiosInstance from "../../../services/axios.instance";
import { API_URL } from "../../../services/apiConfig";
interface RentalSummaryProps {
  daysDifference: number;
  totalAmount: number;
  childSeatAmount: number;
  paiInsuranceAmount: number;
  cdwAmount: number;
  scdwAmount: number;
  carImage: string;
  carModel: string;
  seat: number;
  fuelType: string;
  deliveryFee: number;
  isLastPage: boolean;
  wtpAmount: number;
  merchantId: string;
  airportFee: number;
  additionalDriverFee: number;
  rentalTotalVat?: number;
  rentalTotalStripeFeeFinal?: number;
  // totalRentalPrice: number;

  onDataFromRentalSummary: (data: any) => void;
}

const RentalSummarySecondPage: React.FC<RentalSummaryProps> = ({
  daysDifference,
  totalAmount,
  childSeatAmount,
  paiInsuranceAmount,
  cdwAmount,
  scdwAmount,
  carImage,
  carModel,
  seat,
  fuelType,
  deliveryFee,
  wtpAmount,
  onDataFromRentalSummary,
  isLastPage,
  merchantId,
  airportFee,
  additionalDriverFee,
  rentalTotalVat = 0,
  rentalTotalStripeFeeFinal = 0,

}: RentalSummaryProps) => {
  console.log("RentalSummarySecondPage Props:", {
    daysDifference,
    totalAmount,
    childSeatAmount,
    paiInsuranceAmount,
    cdwAmount,
    scdwAmount,
    deliveryFee,
    wtpAmount,
    merchantId,
    airportFee,
    additionalDriverFee,
    rentalTotalVat,
    rentalTotalStripeFeeFinal,
  });
  const dispatch = useDispatch();
  //const [totalRentalPrice, setTotalRentalPrice] = useState(0);
  const { bookingValues } = useSelector((state: any) => state.bookingValues);
  const isStripeFeeEnabled = String(process.env.REACT_APP_STRIPE_BOOLEAN) === "true";
  console.log(childSeatAmount);
  const [paymentConfig, setPaymentConfig] = useState<{
    initialPaymentPercentage: number;
  } | null>(null);
  const [totalRentalPrice, setTotalRentalPrice] = useState<number>(
    bookingValues?.totalRentalPrice || 0
  );
  const bookingValuesConstant = {
    SCDW: "SCDW",
    CDW: "CDW",
    No: "No",
  };

  const paiInsuranceAmountCommission = Number((paiInsuranceAmount * 0.05).toFixed(2));
  const paiInsuranceAmountVat = Number(((paiInsuranceAmount + paiInsuranceAmountCommission) * 0.05).toFixed(2));
  const paiInsuranceAmountSum = Number((paiInsuranceAmount + paiInsuranceAmountCommission + paiInsuranceAmountVat).toFixed(2));
  const paiInsuranceAmountStripeFee = Number((paiInsuranceAmountSum * 0.0299).toFixed(2));
  const paiInsuranceAmountStripeVat = isStripeFeeEnabled ? Number((paiInsuranceAmountStripeFee * 0.05).toFixed(2)) : 0;
  const paiInsuranceAmountStripe = Number((paiInsuranceAmountStripeFee + paiInsuranceAmountStripeVat).toFixed(2));
  const paiInsuranceAmountFinalAmount = Number((paiInsuranceAmountSum + paiInsuranceAmountStripeFee + paiInsuranceAmountStripeVat).toFixed(2));
  const paiInsuranceAmountDisplayAmount = Number((paiInsuranceAmountFinalAmount - paiInsuranceAmountVat).toFixed(2));

  console.log("PAI Insurance (Formatted):", {
    paiInsuranceAmount,
    paiInsuranceAmountCommission,
    paiInsuranceAmountVat,
    paiInsuranceAmountSum,
    paiInsuranceAmountStripeFee,
    paiInsuranceAmountStripeVat,
    paiInsuranceAmountStripe,
    paiInsuranceAmountFinalAmount,
    paiInsuranceAmountDisplayAmount,
  });


  const cdwAmountCommission = Number((cdwAmount * 0.05).toFixed(2));
  const cdwAmountVat = Number(((cdwAmount + cdwAmountCommission) * 0.05).toFixed(2));
  const cdwAmountSum = Number((cdwAmount + cdwAmountCommission + cdwAmountVat).toFixed(2));
  const cdwAmountStripeFee = Number((cdwAmountSum * 0.0299).toFixed(2));
  const cdwAmountStripeVat = isStripeFeeEnabled ? Number((cdwAmountStripeFee * 0.05).toFixed(2)) : 0;
  const cdwAmountStripe = Number((cdwAmountStripeFee + cdwAmountStripeVat).toFixed(2));
  const cdwAmountFinalAmount = Number((cdwAmountSum + cdwAmountStripeFee + cdwAmountStripeVat).toFixed(2));
  const cdwAmountDisplayAmount = Number((cdwAmountFinalAmount - cdwAmountVat).toFixed(2));

  console.log("CDW Insurance (Formatted):", {
    cdwAmount,
    cdwAmountCommission,
    cdwAmountVat,
    cdwAmountSum,
    cdwAmountStripeFee,
    cdwAmountStripeVat,
    cdwAmountStripe,
    cdwAmountFinalAmount,
    cdwAmountDisplayAmount,
  });


  const scdwAmountCommission = Number((scdwAmount * 0.05).toFixed(2));
  const scdwAmountVat = Number(((scdwAmount + scdwAmountCommission) * 0.05).toFixed(2));
  const scdwAmountSum = Number((scdwAmount + scdwAmountCommission + scdwAmountVat).toFixed(2));
  const scdwAmountStripeFee = Number((scdwAmountSum * 0.0299).toFixed(2));
  const scdwAmountStripeVat = isStripeFeeEnabled ? Number((scdwAmountStripeFee * 0.05).toFixed(2)) : 0;
  const scdwAmountStripe = Number((scdwAmountStripeFee + scdwAmountStripeVat).toFixed(2));
  const scdwAmountFinalAmount = Number((scdwAmountSum + scdwAmountStripeFee + scdwAmountStripeVat).toFixed(2));
  const scdwAmountDisplayAmount = Number((scdwAmountFinalAmount - scdwAmountVat).toFixed(2));

  console.log("SCDW Insurance (Formatted):", {
    scdwAmount,
    scdwAmountCommission,
    scdwAmountVat,
    scdwAmountSum,
    scdwAmountStripeFee,
    scdwAmountStripeVat,
    scdwAmountStripe,
    scdwAmountFinalAmount,
    scdwAmountDisplayAmount,
  });


  const wtpAmountCommission = Number((wtpAmount * 0.05).toFixed(2));
  const wtpAmountVat = Number(((wtpAmount + wtpAmountCommission) * 0.05).toFixed(2));
  const wtpAmountSum = Number((wtpAmount + wtpAmountCommission + wtpAmountVat).toFixed(2));
  const wtpAmountStripeFee = Number((wtpAmountSum * 0.0299).toFixed(2));
  const wtpAmountStripeVat = isStripeFeeEnabled ? Number((wtpAmountStripeFee * 0.05).toFixed(2)) : 0;
  const wtpAmountStripe = Number((wtpAmountStripeFee + wtpAmountStripeVat).toFixed(2));
  const wtpAmountFinalAmount = Number((wtpAmountSum + wtpAmountStripeFee + wtpAmountStripeVat).toFixed(2));
  const wtpAmountDisplayAmount = Number((wtpAmountFinalAmount - wtpAmountVat).toFixed(2));

  console.log("WTP Insurance (Formatted):", {
    wtpAmount,
    wtpAmountCommission,
    wtpAmountVat,
    wtpAmountSum,
    wtpAmountStripeFee,
    wtpAmountStripeVat,
    wtpAmountStripe,
    wtpAmountFinalAmount,
    wtpAmountDisplayAmount,
  });


  const additionalDriverFeeCommission = Number((additionalDriverFee * 0.05).toFixed(2));
  const additionalDriverFeeVat = Number(((additionalDriverFee + additionalDriverFeeCommission) * 0.05).toFixed(2));
  const additionalDriverFeeSum = Number((additionalDriverFee + additionalDriverFeeCommission + additionalDriverFeeVat).toFixed(2));
  const additionalDriverFeeStripeFee = Number((additionalDriverFeeSum * 0.0299).toFixed(2));
  const additionalDriverFeeStripeVat = isStripeFeeEnabled ? Number((additionalDriverFeeStripeFee * 0.05).toFixed(2)) : 0;
  const additionalDriverFeeStripe = Number((additionalDriverFeeStripeFee + additionalDriverFeeStripeVat).toFixed(2));
  const additionalDriverFeeFinalAmount = Number((additionalDriverFeeSum + additionalDriverFeeStripeFee + additionalDriverFeeStripeVat).toFixed(2));
  const additionalDriverFeeDisplayAmount = Number((additionalDriverFeeFinalAmount - additionalDriverFeeVat).toFixed(2));

  console.log("Additional Driver (Formatted):", {
    additionalDriverFee,
    additionalDriverFeeCommission,
    additionalDriverFeeVat,
    additionalDriverFeeSum,
    additionalDriverFeeStripeFee,
    additionalDriverFeeStripeVat,
    additionalDriverFeeStripe,
    additionalDriverFeeFinalAmount,
    additionalDriverFeeDisplayAmount,
  });


  const childSeatCommission = Number((childSeatAmount * 0.05).toFixed(2));
  const childSeatVat = Number(((childSeatAmount + childSeatCommission) * 0.05).toFixed(2));
  const childSeatSum = Number((childSeatAmount + childSeatCommission + childSeatVat).toFixed(2));
  const childSeatStripeFee = Number((childSeatSum * 0.0299).toFixed(2));
  const childSeatStripeVat = isStripeFeeEnabled ? Number((childSeatStripeFee * 0.05).toFixed(2)) : 0;
  const childSeatStripe = Number((childSeatStripeFee + childSeatStripeVat).toFixed(2));
  const childSeatFinalAmount = Number((childSeatSum + childSeatStripeFee + childSeatStripeVat).toFixed(2));
  const childSeatDisplayAmount = Number((childSeatFinalAmount - childSeatVat).toFixed(2));

  console.log("Child Seat (Formatted):", {
    childSeatAmount,
    childSeatCommission,
    childSeatVat,
    childSeatSum,
    childSeatStripeFee,
    childSeatStripeVat,
    childSeatStripe,
    childSeatFinalAmount,
    childSeatDisplayAmount,
  });

  const deliveryFeeCommission = Number((deliveryFee * 0.05).toFixed(2));
  const deliveryFeeVat = Number(((deliveryFee + deliveryFeeCommission) * 0.05).toFixed(2));
  const deliveryFeeSum = Number((deliveryFee + deliveryFeeCommission + deliveryFeeVat).toFixed(2));
  const deliveryFeeStripeFee = Number((deliveryFeeSum * 0.0299).toFixed(2));
  const deliveryFeeStripeVat = isStripeFeeEnabled ? Number((deliveryFeeStripeFee * 0.05).toFixed(2)) : 0;
  const deliveryFeeStripe = Number((deliveryFeeStripeFee + deliveryFeeStripeVat).toFixed(2));
  const deliveryFeeFinalAmount = Number((deliveryFeeSum + deliveryFeeStripeFee + deliveryFeeStripeVat).toFixed(2));
  const deliveryFeeDisplayAmount = Number((deliveryFeeFinalAmount - deliveryFeeVat).toFixed(2));

  console.log("Delivery Fee (Formatted):", {
    deliveryFee,
    deliveryFeeCommission,
    deliveryFeeVat,
    deliveryFeeSum,
    deliveryFeeStripeFee,
    deliveryFeeStripeVat,
    deliveryFeeStripe,
    deliveryFeeFinalAmount,
    deliveryFeeDisplayAmount,
  });

  const calculateTotal = async () => {
    let baseAmount = Number((totalAmount + totalAmount * 0.05).toFixed(2));
    let additionalServicesTotal = 0;
    if (bookingValues.babySeatSelected) {
      additionalServicesTotal += childSeatAmount;
    }
    if (bookingValues.additionalDriverSelected) {
      additionalServicesTotal += additionalDriverFee;
    }
    if (bookingValues.wtpSelected) {
      additionalServicesTotal += wtpAmount;
    }
    if (bookingValues.cdwSelected) {
      additionalServicesTotal += cdwAmount;
    }
    if (bookingValues.scdwSelected) {
      additionalServicesTotal += scdwAmount;
    }

    if (bookingValues.isCarRentalAllowed) {
      additionalServicesTotal += paiInsuranceAmount || 0;
    }

    if (bookingValues.isAirport) {
      additionalServicesTotal += airportFee || 0;
    }

    let deliveryTotal = 0;
    if (bookingValues.deliveryAmount === bookingValuesConstant["No"]) {
      deliveryTotal = deliveryFee || 0;
    }

    // Calculate service charges
    const amountForServiceCharges = Number(
      (baseAmount + additionalServicesTotal + deliveryTotal).toFixed(2),
    );
    const platformCommission = Number(
      (amountForServiceCharges * 0.15).toFixed(2),
    ); // 15% commission
    const stripeFee = Number((amountForServiceCharges * 0.029).toFixed(2)); // 2.9% + 1
    const stripeVat = Number((stripeFee * 0.05).toFixed(2)); // 5% of stripe fee
    const totalServiceCharge = Number(
      (platformCommission + stripeFee + stripeVat).toFixed(2),
    );

    // Calculate final total
    const total = Number(
      (
        baseAmount +
        additionalServicesTotal +
        deliveryTotal +
        totalServiceCharge
      ).toFixed(2),
    );

    console.log("calculateTotal Details:", {
      baseAmount,
      additionalServicesTotal,
      deliveryTotal,
      amountForServiceCharges,
      platformCommission,
      stripeFee,
      stripeVat,
      totalServiceCharge,
      finalTotal: total,
    });
    // setTotalRentalPrice(total);
    // dispatch(
    //   setBookingValues({
    //     ...bookingValues,
    //     totalRentalPrice: total,
    //   })
    // );
    if (total !== totalRentalPrice) {
      setTotalRentalPrice(total);
      dispatch(
        setBookingValues({
          ...bookingValues,
          totalRentalPrice: total,
          baseAmount,
          additionalServicesTotal,
          deliveryTotal,
          serviceCharge: totalServiceCharge,
        }),
      );
    }
  };

  // useEffect(() => {
  //   calculateTotal();
  // }, [bookingValues]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      calculateTotal();
    }, 300);

    return () => clearTimeout(timeoutId);
  }, [
    bookingValues,
    totalAmount,
    childSeatAmount,
    paiInsuranceAmount,
    cdwAmount,
    scdwAmount,
    wtpAmount,
    deliveryFee,
    airportFee,
    additionalDriverFee,
  ]);

  useEffect(() => {
    const fetchMerchantPaymentConfig = async () => {
      try {
        const response = await axiosInstance.get(
          `${API_URL.MERCHANT_PERCENTAGE}/${merchantId}`
        );
        setPaymentConfig(response.data);
        return response.data;
      } catch (error) {
        console.error(error);
      }
    };

    if (isLastPage && merchantId) {
      fetchMerchantPaymentConfig();
    }
  }, [isLastPage, merchantId]);

  // useEffect(() => {
  //   if (bookingValues.selectedOptions === "NO") {
  //     calculateTotal();
  //   }
  // }, [bookingValues.selectedOptions]);
  // useEffect(() => {
  //   console.log("Selected options:", bookingValues.deliveryAmount);
  //   if (bookingValues.deliveryAmount === "No") {
  //     console.log("Inside NO condition");
  //     calculateTotal();
  //   }
  // }, [bookingValues.deliveryAmount]);

  return (
    <div className="col-md-12">
      <div className="card card-custom">
        <div className="card-body">
          <div className="text-white">
            <div className="col-md-12 text-style">
              <h5> Rental Summary </h5>
            </div>
            <div
              className="col-md-9 text-colour dashboard-poppins-font-style fontsize3"
              style={{ textAlign: "left" }}
            >
              Price may change if you exceed 1 hour within the agreed time{" "}
            </div>
            <div className="row pt-2">
              <div className="col-md-6 car-style">
                <img
                  /// src={rental_car}
                  src={carImage}
                  alt="file_browse_icon"
                  className="file_browse_icon"
                />
              </div>
              <div className="col-md-6 text-start ">
                <div className="rent-carmodel" style={{ marginTrim: "none" }}>
                  {carModel}
                </div>
                <img src={stars} alt="img-fluid" className="img-fluid" />
                {/* <div style={{ color: "yellow", textDecoration: "underline" }}>
                  20+ Comments
                </div> */}
              </div>
            </div>
            <div className="row pt-2">
              <div className="col-md-12 text-start">
                <div className="col-md-12 text-start  pb-2 dashboard-poppins-font-style  car-name-search-bold">
                  Features
                </div>
                <div className="d-flex">
                  <div className="">
                    <img
                      src={group_icon}
                      alt="file_browse_icon"
                      className="img-fluid"
                    />
                    <span className="text-colour ps-1">{seat}</span>
                  </div>
                  <div className="ms-4">
                    <img
                      src={petrol_pump}
                      alt="file_browse_icon"
                      className="img-fluid img-width-icon"
                    />
                    <span className="text-colour dashboard-poppins-font-style">
                      {fuelType}
                    </span>
                  </div>
                </div>
                {/* <div className="col-md-12 pt-1">
                  <img
                    src={mileage}
                    alt="file_browse_icon"
                    className="img-fluid img-width-icon"
                    style={{ alignItems: "left" }}
                  />
                  <span className="text-colour ps-1 dashboard-poppins-font-style">
                    Unlimited Mileage
                  </span>
                </div> */}
              </div>
            </div>
            <div className="row pt-3">
              <div className="col-md-12">
                <table className="text-start table-width-custom table-rentalsummery table-amount">
                  <tbody>
                    <tr className="fontsize ">
                      <td className="reantal-td">
                        Total Rental Price{" "}
                        <span style={{ color: "grey" }}>
                          ({daysDifference} Days)
                        </span>
                        <div style={{ color: "grey", fontSize: "11px", fontWeight: "normal" }}>
                          (including service charges)
                        </div>
                      </td>
                      <td>AED {(() => {
                        // const subtotal = totalAmount + (totalAmount * 0.05)

                        return Math.round(totalAmount).toString();
                      })()}</td>
                    </tr>
                    {bookingValues.babySeatSelected && (
                      <tr className="fontsize ">
                        <td className="reantal-td">
                          Extra Baby Seat
                          {/* <div style={{ color: "grey", fontSize: "11px", fontWeight: "normal" }}>
                            (including service charges)
                          </div> */}
                        </td>
                        <td>AED {Math.round(childSeatDisplayAmount).toString() || 0}</td>
                      </tr>
                    )}
                    {bookingValues.additionalDriverSelected && (
                      <tr className="fontsize ">
                        <td className="reantal-td">
                          Additional Driver
                          {/* <div style={{ color: "grey", fontSize: "11px", fontWeight: "normal" }}>
                            (including service charges)
                          </div> */}
                        </td>
                        <td>AED {Math.round(additionalDriverFeeDisplayAmount).toString() || 0}</td>
                      </tr>
                    )}
                    {bookingValues.isCarRentalAllowed && (
                      <tr className="fontsize ">
                        <td className="reantal-td">
                          PAI Insurance
                          {/* <div style={{ color: "grey", fontSize: "11px", fontWeight: "normal" }}>
                            (including service charges)
                          </div> */}
                        </td>
                        <td>AED {Math.round(paiInsuranceAmountDisplayAmount).toString() || 0}</td>
                      </tr>
                    )}

                    {bookingValues.cdwSelected && (
                      <tr className="fontsize ">
                        <td className="reantal-td">
                          CDW Insurance
                          {/* <div style={{ color: "grey", fontSize: "11px", fontWeight: "normal" }}>
                            (including service charges)
                          </div> */}
                        </td>
                        <td>AED {Math.round(cdwAmountDisplayAmount).toString() || 0}</td>
                      </tr>
                    )}
                    {bookingValues.scdwSelected && (
                      <tr className="fontsize ">
                        <td className="reantal-td">
                          SCDW Insurance
                          {/* <div style={{ color: "grey", fontSize: "11px", fontWeight: "normal" }}>
                            (including service charges)
                          </div> */}
                        </td>
                        <td>AED {Math.round(scdwAmountDisplayAmount).toString() || 0}</td>
                      </tr>
                    )}

                    {bookingValues.wtpSelected && (
                      <tr className="fontsize ">
                        <td className="reantal-td">
                          Wind Shield Protection
                          {/* <div style={{ color: "grey", fontSize: "11px", fontWeight: "normal" }}>
                            (including service charges)
                          </div> */}
                        </td>
                        <td>AED {Math.round(wtpAmountDisplayAmount).toString() || 0}</td>
                      </tr>
                    )}

                    {bookingValues.isAirport && (
                      <tr className="fontsize ">
                        <td className="reantal-td">Airport Pickup Fee</td>
                        <td>AED {Math.round(airportFee).toString() || 0}</td>
                      </tr>
                    )}

                    {/* <br /> */}
                    {/* {bookingValues.insuranceType === "SCDW" && (
                      <tr className="fontsize ">
                        <td className="reantal-td">
                          SCDW Insurance{" "}
                          <span style={{ color: "grey", whiteSpace: "nowrap" }}>
                            ({daysDifference} Days)
                          </span>
                        </td>
                        <td>AED { scdwAmount || 0}</td>
                      </tr>
                    )}

                    {bookingValues.insuranceType === "CDW" && (
                      <tr className="fontsize ">
                        <td className="reantal-td">
                          CDW Insurance{" "}
                          <span style={{ color: "grey", whiteSpace: "nowrap" }}>
                            ({daysDifference} Days)
                          </span>
                        </td>
                        <td>AED {cdwAmount || 0}</td>
                      </tr>
                    )} */}

                    {/* <br /> */}
                    {bookingValues.deliveryAmount === "No" && (
                      <tr className="fontsize ">
                        <td className="reantal-td">
                          Pickup And Delivery Charges{" "}
                          {/* <div style={{ color: "grey", fontSize: "11px", fontWeight: "normal" }}>
                            (including service charges)
                          </div> */}
                          <span style={{ color: "grey" }}>
                            {/* (including delivery and pickup) */}
                            {/* ({daysDifference} Days) */}
                          </span>
                        </td>
                        <td>AED {Math.round(deliveryFeeDisplayAmount).toString() || 0}</td>
                      </tr>
                    )}
                    {isLastPage && (
                      <>
                        <tr style={{ height: "40px" }}>
                          <td colSpan={2}></td>
                        </tr>
                        <tr className="fontsize2">
                          <td className="reantal-td">VAT</td>
                          <td>
                            <strong>AED {(() => {
                              const baseForService = (bookingValues.babySeatSelected ? childSeatVat : 0) +
                                (bookingValues.additionalDriverSelected ? additionalDriverFeeVat : 0) +
                                (bookingValues.wtpSelected ? wtpAmountVat : 0) +
                                (bookingValues.cdwSelected ? cdwAmountVat : 0) +
                                (bookingValues.scdwSelected ? scdwAmountVat : 0) +
                                (bookingValues.isCarRentalAllowed ? paiInsuranceAmountVat || 0 : 0) +
                                (bookingValues.deliveryAmount === "No" ? deliveryFeeVat || 0 : 0) +
                                rentalTotalVat;

                              return baseForService.toFixed(2);
                            })()}</strong>
                          </td>
                        </tr>
                        <tr className="fontsize2">
                          <td className="reantal-td">Grand Total</td>
                          <td>
                            <strong>AED {(() => {
                              const rentalPrice = Math.round(totalAmount);
                              const babySeat = bookingValues.babySeatSelected ? Math.round(childSeatDisplayAmount) : 0;
                              const additionalDriver = bookingValues.additionalDriverSelected ? Math.round(additionalDriverFeeDisplayAmount) : 0;
                              const pai = bookingValues.isCarRentalAllowed ? Math.round(paiInsuranceAmountDisplayAmount) : 0;
                              const cdw = bookingValues.cdwSelected ? Math.round(cdwAmountDisplayAmount) : 0;
                              const scdw = bookingValues.scdwSelected ? Math.round(scdwAmountDisplayAmount) : 0;
                              const wtp = bookingValues.wtpSelected ? Math.round(wtpAmountDisplayAmount) : 0;
                              const airport = bookingValues.isAirport ? Math.round(airportFee || 0) : 0;
                              const delivery = bookingValues.deliveryAmount === "No" ? Math.round(deliveryFeeDisplayAmount) : 0;

                              const totalVat = (
                                (bookingValues.babySeatSelected ? childSeatVat : 0) +
                                (bookingValues.additionalDriverSelected ? additionalDriverFeeVat : 0) +
                                (bookingValues.wtpSelected ? wtpAmountVat : 0) +
                                (bookingValues.cdwSelected ? cdwAmountVat : 0) +
                                (bookingValues.scdwSelected ? scdwAmountVat : 0) +
                                (bookingValues.isCarRentalAllowed ? paiInsuranceAmountVat : 0) +
                                (bookingValues.deliveryAmount === "No" ? deliveryFeeVat : 0) +
                                rentalTotalVat
                              );
                              const roundedTotalVat = Math.round(totalVat);

                              const grandTotal =
                                rentalPrice +
                                babySeat +
                                additionalDriver +
                                pai +
                                cdw +
                                scdw +
                                wtp +
                                airport +
                                delivery +
                                roundedTotalVat;

                              return grandTotal.toString();
                            })()}</strong>
                          </td>
                        </tr>
                      </>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RentalSummarySecondPage;
